import { Ksps as Ksps$2, Ksp } from './Ksps.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import Icon from '../../Icon/Icon.js';
import { ICON_UI_CHECKMARK } from '../../../icons/ICON_UI_CHECKMARK.js';
import useUniqueId from '../../../hooks/useUniqueId.js';

var Ksps = function Ksps(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/jsx(Ksps$2, {
    children: items.map(function (value) {
      return /*#__PURE__*/jsxs(Ksp, {
        children: [/*#__PURE__*/jsx(Icon, {
          path: ICON_UI_CHECKMARK,
          size: "xxs"
        }), value]
      }, useUniqueId('value-proposition-'));
    })
  });
};
var Ksps$1 = Ksps;

export { Ksps$1 as default };
//# sourceMappingURL=Ksps.js.map
